class FakeEventTracker
  constructor: ->
    @trackedEvents = {}
    @print_events = false

  register: (eventName, {trigger, send, _init}) ->
    throw "name is required when registering an event" unless eventName?
    throw "event '#{eventName}' is already registered" if eventName of @trackedEvents
    throw "send function is required when registering an event" unless send?
    @trackedEvents[eventName] =
      trigger : trigger
      init    : @fake_init
      send    : @fake_send

  fake_init: (eventName, el) ->
    return unless @print_events
    console.log("init #{eventName} called for #{el}")
  fake_send: (eventName, el) ->
    return unless @print_events
    console.log("send #{eventName} called on element #{el}")

  reset: ->
    @trackedEvents = {}

  attach: (root) ->
    $.each @trackedEvents, (eventName, event) ->
      if event.trigger?
        $(root).find("[data-track='#{eventName}']").each ->
          el = $(@)
          event.init(eventName, el) if event.init?
          if event.trigger == 'load'
            event.send(eventName, el)
          else
            el.on "#{event.trigger}.tracking", (e, options) ->
              return if options && options.syntheticClick
              event.send(eventName, el)

  trigger: (eventName, args...) ->
    if eventName of @trackedEvents
      @trackedEvents[eventName].send(eventName, args...)
    else
      throw (new Error("FakeEventTracker: Unknown event '#{eventName}'"))

module.exports.FakeEventTracker = FakeEventTracker
